import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/representante-autorizado-ec-rep")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/representante-autorizado-ec-rep", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/regulatory-affairs/representante-autorizado-eu-rep", replace: true });
  },
});
